<label for="exampleFormControlInput1" class="form-label">Company <sup *ngIf="isRequired">*</sup></label>
<input *ngIf="companies?.length === 1" type="text" class="form-control" [disabled]="true" [value]="companies[0].name" />
<select
  *ngIf="companies?.length > 1"
  class="form-select"
  aria-label="Default select example"
  (change)="onSelectChange($event.target.value)"
  [formControl]="companyFormControl"
  [ngClass]="{
    'is-invalid': companyFormControl.errors && (companyFormControl.touched || showError) && isRequired
  }">
  <option selected disabled="true" value="">Select Company</option>
  <option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</option>
</select>
<div *ngIf="companyFormControl.errors && (companyFormControl.touched || showError)" class="invalid-feedback">
  <div *ngIf="companyFormControl.errors.required && isRequired">This is mandatory field, Kindly select company</div>
</div>
